"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useCallback } from "react";
import { useSearchParams } from "next/navigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { useClientNavigation } from "@/hooks/useClientNavigation";
import { getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";
interface WaveNavigationOptions {
  isDirectMessage?: boolean;
  serialNo?: number | string | null;
}
const getWaveFromWindow = (): string | null => {
  if (globalThis.window === undefined) return null;
  const url = new URL(globalThis.window.location.href);
  const wave = url.searchParams.get("wave");
  return typeof wave === "string" ? wave : null;
};
const getRouteContext = (): {
  isOnWaves: boolean;
  isOnMessages: boolean;
} => {
  if (globalThis.window === undefined) {
    return {
      isOnWaves: false,
      isOnMessages: false
    };
  }
  const pathname = globalThis.window.location.pathname;
  return {
    isOnWaves: pathname === "/waves" || pathname.startsWith("/waves/"),
    isOnMessages: pathname === "/messages" || pathname.startsWith("/messages/")
  };
};
export function useActiveWaveManager() {
  const $ = _c(10);
  const searchParams = useSearchParams();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.get("wave");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waveId = t0;
  const waveFromSearchParams = typeof waveId === "string" ? waveId : null;
  let t1;
  if ($[2] !== isApp) {
    t1 = (waveId_0, options) => {
      const isDirectMessage = options?.isDirectMessage ?? false;
      const serialNo = options?.serialNo ?? undefined;
      return waveId_0 ? getWaveRoute({
        waveId: waveId_0,
        serialNo,
        isDirectMessage,
        isApp
      }) : getWaveHomeRoute({
        isDirectMessage,
        isApp
      });
    };
    $[2] = isApp;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const buildUrl = t1;
  const canUsePushState = _temp;
  let t2;
  if ($[4] !== buildUrl || $[5] !== waveFromSearchParams) {
    t2 = {
      initialState: waveFromSearchParams,
      buildUrl,
      parseUrl: getWaveFromWindow,
      canUsePushState
    };
    $[4] = buildUrl;
    $[5] = waveFromSearchParams;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    state: activeWaveId,
    navigate: setActiveWave
  } = useClientNavigation(t2);
  let t3;
  if ($[7] !== activeWaveId || $[8] !== setActiveWave) {
    t3 = {
      activeWaveId,
      setActiveWave
    };
    $[7] = activeWaveId;
    $[8] = setActiveWave;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(_targetUrl, options_0) {
  const {
    isOnWaves,
    isOnMessages
  } = getRouteContext();
  const isDirectMessage_0 = options_0?.isDirectMessage ?? false;
  return !isDirectMessage_0 && isOnWaves || isDirectMessage_0 && isOnMessages;
}